"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validators = exports.InvalidConfigurationException = exports.Configurable = void 0;
exports.validateOptions = validateOptions;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const isFQDN_1 = __importDefault(require("validator/lib/isFQDN"));
const isIP_1 = __importDefault(require("validator/lib/isIP"));
const isEmpty_2 = __importDefault(require("validator/lib/isEmpty"));
const isURL_1 = __importDefault(require("validator/lib/isURL"));
function validate(value, options, validator) {
    if (Array.isArray(validator)) {
        for (let v of validator) {
            const error = Array.isArray(v)
                ? validate(value, options, v)
                : v(value, options);
            if (error) {
                return error;
            }
        }
    }
    else {
        return validator(value, options);
    }
}
function validateOptions(schema, options) {
    const errors = Object.entries(schema).reduce((acc, [key, validator]) => {
        const value = options[key];
        const result = validate(value, options, validator);
        if (result) {
            acc[key] = result;
        }
        return acc;
    }, {});
    if (!(0, isEmpty_1.default)(errors)) {
        throw new InvalidConfigurationException(errors);
    }
}
class Configurable {
    constructor(options) {
        const mergedOptions = { ...this.defaultOptions(), ...options };
        this.options = mergedOptions;
        this.validateOptions();
    }
    defaultOptions() {
        return {};
    }
    validateOptions() {
        validateOptions(this.schema, this.options);
    }
}
exports.Configurable = Configurable;
class InvalidConfigurationException extends Error {
    constructor(details) {
        super('Invalid configuration');
        this.details = details;
    }
}
exports.InvalidConfigurationException = InvalidConfigurationException;
function isType(type) {
    return val => val && typeof val !== type && `expected ${type}`;
}
exports.validators = {
    string() {
        return isType('string');
    },
    number() {
        return isType('number');
    },
    boolean() {
        return isType('boolean');
    },
    integer({ unsigned = true } = {}) {
        return val => val &&
            !(Number.isInteger(val) || (unsigned && val < 0)) &&
            `expected integer (unsigned: ${unsigned})`;
    },
    host() {
        return val => !((0, isFQDN_1.default)(val) || (0, isIP_1.default)(val)) && 'expected fqdn or ip';
    },
    url({ require_tld = false, require_protocol = true } = {}) {
        return val => val &&
            !(0, isURL_1.default)(val, { require_tld, require_protocol }) &&
            'expected valid url';
    },
    required({ allowEmptyString = false } = {}) {
        return val => (val === null ||
            val === undefined ||
            (!allowEmptyString &&
                typeof val === 'string' &&
                (0, isEmpty_2.default)(val, { ignore_whitespace: true }))) &&
            'required';
    },
    plainObject() {
        return val => val && !(0, isPlainObject_1.default)(val) && 'expected simple object';
    },
    array() {
        return val => val && !Array.isArray(val) && 'expected array';
    },
    notEmpty() {
        return val => {
            if (Array.isArray(val)) {
                return !val.length && 'expected not empty';
            }
            else if (typeof val === 'object') {
                return !Object.keys(val).length && 'expected not empty';
            }
        };
    },
    oneOf(keys) {
        return (val, options) => !val &&
            !keys.some(key => !!options[key]) &&
            `or one of [${keys.join()}] required`;
    },
    requiredIf(dependsOn) {
        return (val, options) => options[dependsOn] && !val && `required when '${dependsOn}' is defined`;
    },
};
//# sourceMappingURL=configurable.js.map